import { useEffect, useState } from "react";
import Heading from "../../Heading";
import Icon from "../../Icon";
import * as styles from "./styles.module.scss";

export function RichTextTableOfContents({
  title,
}: Partial<TableOfContentsComponent>) {
  const [tableOfContents, setTableOfContents] = useState<
    Array<{ id: string; text: string | null }>
  >([]);

  useEffect(() => {
    if (tableOfContents.length === 0) {
      const headings = document.querySelectorAll(".chapter-heading");
      headings.forEach((heading) => {
        const id = heading.id;
        const text = heading.textContent;
        setTableOfContents((prev) => [...prev, { id, text }]);
      });
    }
  }, []);

  function handleAnchorClick(id: string) {
    const yOffset = -120;
    const element = document.getElementById(id);
    const y =
      element &&
      element.getBoundingClientRect().top + window.pageYOffset + yOffset;

    window.scrollTo({ top: y || 0, behavior: "smooth" });
  }

  return (
    <div className={styles.tableContainer}>
      <Heading level={3}>{title || "Table of contents"}</Heading>
      <ul>
        {tableOfContents.map((item) => (
          <li key={item.id} className={styles.tableItem}>
            <Icon name="tocArrow" />
            <span
              onClick={() => handleAnchorClick(item.id)}
              tabIndex={0}
              role="link"
              aria-hidden="true"
            >
              {item.text}
            </span>
          </li>
        ))}
      </ul>
    </div>
  );
}
